"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var filterData = function filterData(data, columns, filterState) {
  if ((0, _isEmpty.default)(filterState)) return data;
  var columnsWithManualFiltersKeys = columns.filter(function (col) {
    return col && col.filters && col.filters.length > 0 && !col.filtered && filterState[col.key];
  }).map(function (col) {
    return col.key;
  });

  if (columnsWithManualFiltersKeys.length < 1) {
    return data;
  }

  return data.filter(function (item) {
    return columnsWithManualFiltersKeys.some(function (key) {
      return new RegExp(filterState[key].join('|')).test(item[key]);
    });
  });
};

var _default = filterData;
exports.default = _default;